export function validarCPF(cpf: string) {
  cpf = cpf.replace(/[^\d]+/g, "");
  if (cpf == "") return false;
  // Elimina CPFs invalidos conhecidos
  if (
    cpf.length != 11 ||
    cpf == "00000000000" ||
    cpf == "11111111111" ||
    cpf == "22222222222" ||
    cpf == "33333333333" ||
    cpf == "44444444444" ||
    cpf == "55555555555" ||
    cpf == "66666666666" ||
    cpf == "77777777777" ||
    cpf == "88888888888" ||
    cpf == "99999999999"
  )
    return false;
  // Valida 1o digito
  let add = 0;
  for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
  let rev = 11 - (add % 11);
  if (rev == 10 || rev == 11) rev = 0;
  if (rev != parseInt(cpf.charAt(9))) return false;
  // Valida 2o digito
  add = 0;
  for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev == 10 || rev == 11) rev = 0;
  if (rev != parseInt(cpf.charAt(10))) return false;
  return true;
}

export function formatCPF(cpf: string) {
  if (!cpf) return cpf;
  const cleanedCPF = cpf.replace(/\D/g, "");
  const match = cleanedCPF.match(/^(\d{3})(\d{3})(\d{3})(\d{2})$/);

  if (match) {
    return `${match[1]}.${match[2]}.${match[3]}-${match[4]}`;
  }

  // Antes, o que não casava com o padrão de CPF era cortado em 14 caracteres.
  // Nos coletivos, que têm o CNPJ gravado neste campo, isso exibia
  // "02.831.210/000" no lugar de "02.831.210/0002-38" — e, se o operador
  // tocasse no campo, o valor truncado ia parar no banco. Se não é um CPF
  // válido, devolvemos o conteúdo como está.
  return cpf;
}

export function formatCNPJ(cnpj: string) {
  if (!cnpj) return cnpj;
  const cleanedCNPJ = cnpj.replace(/\D/g, "");
  const match = cleanedCNPJ.match(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/);
  if (match) {
    return `${match[1]}.${match[2]}.${match[3]}/${match[4]}-${match[5]}`;
  }
  return cnpj;
}

// ------------------------------------------------------------------
// Documentos no formulário de sócio (CPF / CNPJ)
//
// Nenhum dos dois é obrigatório no banco (ambos são opcionais e únicos).
// Coletivos e coletivos remidos usam CNPJ; os demais, CPF. Por isso a
// regra é "pelo menos um preenchido", e não "os dois obrigatórios".
// ------------------------------------------------------------------

/** Nunca devolve null/undefined para o input, evitando campo descontrolado. */
export const formatCPFInput = (value: any) => formatCPF(value) ?? "";
export const formatCNPJInput = (value: any) => formatCNPJ(value) ?? "";

/**
 * Grava o documento no padrão da base — 23.158 dos 23.240 CPFs estão
 * formatados. Antes gravava o que fosse digitado, então quem digitasse só
 * os números criava um registro fora do padrão.
 *
 * Conservador como a máscara de telefone: só formata o que é
 * inequivocamente CPF (11 dígitos) ou CNPJ (14). Qualquer outro conteúdo
 * — inclusive o dado sujo herdado, como "104721818117-85" — é gravado
 * exatamente como está, sem truncar nem completar.
 *
 * Campo esvaziado vira `null`, não string vazia: as colunas são únicas no
 * banco, então o segundo registro salvo com "" quebraria.
 */
export const parseDocument = (value: any) => {
  const original = (value ?? "").toString().trim();
  if (original === "") return null;

  const digitos = original.replace(/\D/g, "");
  if (digitos.length === 11) return formatCPF(digitos);
  if (digitos.length === 14) return formatCNPJ(digitos);

  return original;
};

const hasDigits = (value: any) => !!(value ?? "").toString().replace(/\D/g, "");

/** Exige ao menos um documento preenchido (CPF ou CNPJ). */
export const validateDocument = (_value: any, allValues: any) =>
  hasDigits(allValues?.cpf) || hasDigits(allValues?.cnpj)
    ? undefined
    : "Informe ao menos um documento: CPF ou CNPJ";
